<template>
  <div class="edit-references-and-notes">
        <b-tabs pills>
          <b-card no-body>
            <b-tabs card>
              <b-tab title="Referenser" active>
                <b-row class="general-info justify-content-md-center">
                  <b-col lg="12">
                    <h3>Referenser</h3>
                    <mu-raised-button class="demo-raised-button" label="Lägg till referens" icon="add" primary @click="showCreateReferenceDialog"/>
                    <hr>
                    <mu-table ref="table" :showCheckbox="false" class="mu-table">
                      <mu-thead>
                        <mu-tr>
                          <mu-th class="small">Redigera</mu-th>
                          <mu-th class="small">Name</mu-th>
                          <mu-th>Text</mu-th>
                        </mu-tr>
                      </mu-thead>
                      <mu-tbody>
                        <mu-tr v-for="reference in references" v-bind:key="reference.id">
                          <mu-td><i class="fa fa-pencil" @click="showEditReference(reference)"></i></mu-td>
                          <mu-td>{{ reference.name }}</mu-td>
                          <mu-td>{{ reference.text }}</mu-td>
                        </mu-tr>
                      </mu-tbody>
                    </mu-table>
                  </b-col>
                </b-row>
              </b-tab>
              <b-tab title="Noter">
                <b-row class="general-info justify-content-md-center">
                  <b-col lg="12">
                    <h3>Noter</h3>
                    <mu-raised-button class="demo-raised-button" label="Lägg till not" icon="add" primary @click="showCreateNoteDialog"/>
                    <hr>
                    <mu-table ref="table" :showCheckbox="false" class="mu-table">
                      <mu-thead>
                        <mu-tr>
                          <mu-th class="small">Redigera</mu-th>
                          <mu-th class="small">Name</mu-th>
                          <mu-th>Text</mu-th>
                        </mu-tr>
                      </mu-thead>
                      <mu-tbody>
                        <mu-tr v-for="note in notes" v-bind:key="note.id">
                          <mu-td><i class="fa fa-pencil" @click="showEditNote(note)"></i></mu-td>
                          <mu-td>{{ note.name }}</mu-td>
                          <mu-td>{{ note.text }}</mu-td>
                        </mu-tr>
                      </mu-tbody>
                    </mu-table>
                  </b-col>
                </b-row>
              </b-tab>
              <b-tab title="Rapporter">
                <b-row class="general-info justify-content-md-center">
                  <b-col lg="12">
                    <h3>Rapporter</h3>
                    <hr>
                    <div class="report-container">
                      <div class="report-item" v-for="report in reports" :key="report.reportName">
                        <div class="report-item__left">
                          <span class="report-item__title">{{report.reportName}}</span>
                          <p class="report-item__description">{{report.reportDescription}}</p>
                        </div>
                        <button class="report-item__right" @click="downloadReport(report.reportUrl)">
                          <mu-icon value="download" />
                        </button>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-tab>
            </b-tabs>
          </b-card>
          </b-tabs>
    <mu-dialog :open="showReferenceDialog" title="Lägg till referens">
      <create-reference @close="closeReferenceDialog" :edit-reference="editReference"></create-reference>
    </mu-dialog>
    <mu-dialog :open="showNoteDialog" title="Lägg till not">
      <create-note @close="closeNoteDialog" :edit-note="editNote"></create-note>
    </mu-dialog>
  </div>
</template>

<script>
import CreateReference from '../components/CreateReference'
import CreateNote from '../components/CreateNote'
import { onMounted, ref } from '@vue/composition-api'
import { clickTracker } from '@/services/helpers'
import axios from 'axios'

export default {
  name: 'EditReferencesAndNotes',
  data () {
    return {
      showReferenceDialog: false,
      editReference: null,
      showNoteDialog: false,
      editNote: null
    }
  },
  methods: {
    showCreateReferenceDialog () {
      this.showReferenceDialog = true
    },
    closeReferenceDialog () {
      this.showReferenceDialog = false
      this.editReference = null
    },
    showEditReference (reference) {
      this.editReference = reference
      this.showReferenceDialog = true
    },
    showCreateNoteDialog () {
      this.showNoteDialog = true
    },
    closeNoteDialog () {
      this.showNoteDialog = false
      this.editNote = null
    },
    showEditNote (note) {
      this.editNote = note
      this.showNoteDialog = true
    }
  },
  computed: {
    references () {
      let item = this.$store.getters.references
      if (!item) return ''
      return item || ''
    },
    notes () {
      let item = this.$store.getters.notes
      if (!item) return ''
      return item || ''
    }
  },
  components: {
    'create-reference': CreateReference,
    'create-note': CreateNote
  },
  setup () {
    const reports = ref([])

    onMounted(() => {
      getReports()
      clickTracker('keyAdminOverview')
    })

    function getReports () {
      axios.get('getReportList')
        .then((result) => {
          if (result.data) {
            reports.value = result.data
          }
        })
        .catch((error) => {
          console.log(error)
        })
    }

    function downloadReport (url) {
      location.href = `${process.env.BASE_URL}${url}`
    }
    return {
      reports,
      downloadReport
    }
  }
}
</script>

<style lang="scss">
.edit-references-and-notes {
  .mu-table {
    width: 700px;
  }
  .mu-th.small {
    width: 82px;
  }
  .mu-td {
    white-space: normal;
  }
}
.report-container {
  display: grid;
  gap: 8px;
}
.report-item {
  align-items: center;
  padding: 6px 0px 6px 0px;
  background-color: #eef2f2;
  display: flex;
  border-radius: 5px;
}
.report-item__left {
  padding-left: 12px;
  flex-grow: 1;
}
.report-item__title {
  font-weight: 700;
}
.report-item__description {
  margin-left: 6px;
}
.report-item__right {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 10%;
  border: none;
  background-color: #eef2f2;
}
</style>

